export class FileUp {
    public file: File;
    private _status;

    constructor(file: File) {
        this.file = file;
        this._status = '';
    }
    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }
}
